import script from "./DesiredView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesiredView.vue?vue&type=script&lang=ts&setup=true"

import "./DesiredView.vue?vue&type=style&index=0&id=fd491a98&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd491a98"]])

export default __exports__